<template>
  <div class="container public">
    <div class="col-sm-3 m-b-xs">

    </div>
    <div class="row justify-content-center col-sm-6 m-b-xs " style="margin-top: 30px;">
      <div class="form">
        <Logo/>
        <form @submit.prevent="submitForm">
          <div v-show="errorMessage" class="alert alert-danger failed">{{ errorMessage }}</div>
          <div class="form-group">
            <label for="username">账号</label>
            <input type="text" class="form-control" id="username" v-model="form.username">
            <div class="field-error" v-if="$v.form.username.$dirty">
              <div class="error" v-if="!$v.form.username.required">账号未填写</div>
            </div>
          </div>
          <div class="form-group">
            <label for="password">密码</label>
            <input type="password" class="form-control" id="password" v-model="form.password">
            <div class="field-error" v-if="$v.form.password.$dirty">
              <div class="error" v-if="!$v.form.password.required">密码未填写</div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-block">登录</button>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    required
  } from 'vuelidate/lib/validators'
  import {
    login
  } from '@/services/authentication'
  import Logo from '@/components/Logo.vue'
  import PageFooter from './layout/PageFooter.vue'

  export default {
    name: 'LoginPage',
    data: function() {
      return {
        form: {
          username: '',
          password: ''
        },
        errorMessage: ''
      }
    },
    components: {
      Logo,
      PageFooter
    },
    validations: {
      form: {
        username: {
          required
        },
        password: {
          required
        }
      }
    },
    methods: {
      submitForm() {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }

        login(this.form).then(res => {
          let msgCode  = res.code;
          if(msgCode == 1){
            this.$message.error(res.msg);
            return;
          }
          console.log(res);
          //return ;
          if (res.data.token != '' ) {
            //localStorage.setItem('token',res.data.token);
            this.$store.dispatch('login', res)
            this.$router.push({
              name: 'home'
            })
          } else {
            this.errorMessage = '请输入正确的用户名或密码';
          }

        }).catch((error) => {
          console.log(error);
          this.errorMessage = error.message
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .links {
    margin: 30px 0 50px 0;
    text-align: center;
  }
</style>
